import React from "react";

import { FormHelperText, makeStyles, Typography } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";
import { ErrorMessage, Form, Formik } from "formik";
import * as yup from "yup";

import InputLabel from "../../../components/Form/InputLabel";
import TextField from "../../../components/Form/TextField";
import DialogActions from "../../../components/Form/DialogActions";
import { requiredField } from "../../../constants/messages";
import { rejectSurvey } from "../../../api/hospital";

const useStyles = makeStyles((theme: Theme) => ({
  form: { padding: theme.spacing(3.2) },
  error: { color: theme.palette.error.main },
}));

const declineModalSchema = yup.object().shape({
  explanation: yup.string().required(requiredField),
});

type DeclineRequestFormProps = {
  handleClose: () => void;
  handleDeny?: () => void;
  hospitalId: number;
};

export default function DeclineRequestForm({
  handleClose,
  handleDeny,
  hospitalId,
}: DeclineRequestFormProps) {
  const classes = useStyles();

  return (
    <Formik
      initialValues={{ explanation: "" }}
      validationSchema={declineModalSchema}
      validateOnBlur={false}
      validateOnChange={false}
      onSubmit={async (values) => {
        await rejectSurvey(hospitalId, values.explanation);
        handleDeny?.();
      }}
    >
      {({ values, handleChange, handleSubmit }) => (
        <Form className={classes.form}>
          <Typography variant="body1">
            Ovim ćete odbiti podatke o ustanovi. Ova akcija je nepovratna. U
            nastavku, molimo Vas da obrazložite razlog odbijanja zahtjeva.
          </Typography>
          <InputLabel>Razlog odbijanja:</InputLabel>
          <TextField
            onChange={handleChange}
            multiline
            fullWidth
            minRows={10}
            value={values.explanation}
            name="explanation"
          />
          <ErrorMessage
            name={"explanation"}
            component={FormHelperText}
            className={classes.error}
          />
          <DialogActions
            handleClose={handleClose}
            handleSubmit={handleSubmit}
          />
        </Form>
      )}
    </Formik>
  );
}
